import httpClientPrivate from '../../../libs/httpClient/httpClientPrivate'
import api from '@/constant/END_POINT'
import { useMutation } from '@tanstack/react-query'
import message from '@/libs/message'

const fetchDeleteHealthClaimApproveLevel = async (id: string) => {
  const response = await httpClientPrivate.delete(api.backoffice.deleteHealthClaimApproveLevel(id))
  return response.data
}

const useDeleteHealthClaimApproveLevel = () => {
  const mutationKey = ['useDeleteHealthClaimApproveLevel']
  const mutationFn = async (id: string) => await fetchDeleteHealthClaimApproveLevel(id)

  return useMutation({
    mutationFn,
    mutationKey,
    onSuccess: () => message.success('ลบข้อมูลระดับอนุมัติสำเร็จ'),
    onError: () => message.error('ลบข้อมูลระดับอนุมัติไม่สำเร็จ'),
  })
}

export { useDeleteHealthClaimApproveLevel, fetchDeleteHealthClaimApproveLevel }
